import * as React from 'react';
import { useDispatch } from 'react-redux';

import { ZoomInButton } from './ZoomInButton';
import { closeOfferPreview } from '../../../../../common/actions/closeOfferPreview/closeOfferPreview';
import { TThunkDispatch } from '../../../../../common/types/redux';
import { useMapController } from '../../../../controller/useMapController';
import { useReloadHybridSearchAfterMapInteraction } from '../../hooks/useReloadHybridSearchAfterMapInteraction';
import { useTrackMapInteraction } from '../../utils/useTrackMapInteraction';

export const ZoomInButtonContainer: React.FC = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const controller = useMapController();
  const reloadHybridSearchAfterMapInteraction = useReloadHybridSearchAfterMapInteraction();
  const trackMapInteractions = useTrackMapInteraction();

  const handleZoomIn = React.useCallback(() => {
    dispatch(closeOfferPreview());

    const zoom = controller.getZoom();
    const [, maxZoom] = controller.getZoomRange();
    if (zoom >= maxZoom) {
      return;
    }

    controller.zoomIn(() => reloadHybridSearchAfterMapInteraction({ mapSnapshot: controller.getSnapshot() }));
  }, [controller, dispatch, reloadHybridSearchAfterMapInteraction]);

  return <ZoomInButton onZoomIn={handleZoomIn} onClick={trackMapInteractions} />;
};
